
import './style.scss';
import { Box, Grid, SxProps, Typography } from '@mui/material';
import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';
import { IMuiIcon } from '../../interfaces/IMaterial';

export interface IFormOptionBadgeProps {
    horizontal: 'left' | 'right';
    vertical: 'top' | 'bottom';
    content: JSX.Element | JSX.Element[];
    className?: string;
}

interface IFormOptionProps {
    title: string;
    type: 'radio' | 'checkbox';
    subtitle?: string;
    name?: string;
    value?: any;
    selected?: boolean;
    disabled?: boolean;
    required?: boolean;
    className?: string;
    onClick?: () => void;
    Icon?: IMuiIcon;
    orientation: 'horizontal' | 'vertical';
    badges?: IFormOptionBadgeProps[];
    selectedProps?: {
        className?: string;
        sx?: SxProps;
    };
}


const FormOption: React.FC<IFormOptionProps> = ({
    title,
    type = 'radio',
    subtitle = undefined,
    name = undefined, 
    value = undefined,
    selected = false,
    disabled = false,
    required = false,
    className = '',
    onClick = () => {},
    Icon = undefined,
    orientation,
    badges = undefined,
    selectedProps = undefined,
}) => {
    let props = {} as SxProps;
    className = `orientation-${orientation} ${className}`;
    
    if (Icon === undefined) {
        Icon = RadioButtonUnchecked;

        if (selected) {
            Icon = RadioButtonChecked;
        }
    }

    if (selected) {
        className = `${className} selected`;

        if (selectedProps !== undefined) {
            props = selectedProps.sx as SxProps;
            className = `${className} ${selectedProps.className ?? ''}`
        }
    }

    if (disabled) {
        className = `${className} disabled`;
    }
    

    return (
        <Grid 
            container 
            className={`formoption-default ${className}`} 
            onClick={() => {
                if (!disabled) {
                    onClick();
                }
            }}
            sx={props}
        >
            <Icon className='formoption-icon' />

            {
                name && <input type={type} className='formoption-input' name={name} value={value} required={required} checked={!disabled && selected} />
            }

            <Box className='width-100pc'>
                <Typography variant='subtitle2' className='formoption-title'> {title} </Typography>
                {
                    subtitle && <Typography variant='subtitle2' className='formoption-subtitle'> {subtitle} </Typography>
                }
            </Box>

            {
                badges && badges.map((b, index) => {
                    return <Box className={`formoption-badge ${b.className} align-${b.horizontal} align-${b.vertical}`} key={index}>
                        {b.content}
                    </Box>;
                })
            }
        </Grid>
    );
}

export default FormOption;